import * as R from 'ramda';
import React, { useState, useCallback } from 'react';
// helpers/constants
import * as GC from '../constants';
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncRefTypes = () => {
  const [referenceTypes, setReferenceTypes] = useState({});

  const getRefTypesRequest = useCallback(async (branchGuid, scopeName) => {
    const scopesRes = await sendRequest('get', endpointsMap.referenceTypeScopes);

    const { data: scopes, status: scopesStatus } = scopesRes;

    if (G.isResponseSuccess(scopesStatus)) {
      const scopeGuid = R.compose(
        R.prop(GC.FIELD_GUID),
        R.find(R.propEq(scopeName, 'name')),
      )(R.or(scopes, []));

      const params = { scopeGuid, [GC.FIELD_BRANCH_GUID]: branchGuid };

      const { data: referenceTypes, status: referenceTypesStatus } = await sendRequest(
        'get',
        endpointsMap.availableReferenceTypesForScope,
        { params },
      );

      if (G.isResponseSuccess(referenceTypesStatus)) {
        setReferenceTypes((prev) => ({ ...prev, [scopeName]: referenceTypes }));
      }
    } else {
      G.handleFailResponseSimple(scopesRes, false, 'withAsyncRefTypes -> getRefTypesRequest');
    }
  }, []);

  return { referenceTypes, getRefTypesRequest };
};

export const withAsyncRefTypes = (Component) => (props) => {
  const refTypes = useAsyncRefTypes();

  return <Component {...props} {...refTypes} />;
};
